module.exports = __webpack_public_path__ + "static/media/5DPO6.48fb9853.jpg";